import { __assign } from "tslib";
import { app } from '@ekuaibao/whispered';
import { addRumAction } from '../hosting/dataflux-rum';
export var DeviceType;
(function (DeviceType) {
    DeviceType["PC"] = "pc";
    DeviceType["APP"] = "app";
})(DeviceType || (DeviceType = {}));
export var FillMode;
(function (FillMode) {
    FillMode["CREATE"] = "create";
    FillMode["EDITDRAFT"] = "editdraft";
})(FillMode || (FillMode = {}));
var AIFillFormTracker = (function () {
    function AIFillFormTracker() {
    }
    AIFillFormTracker.trackAIFillFormStart = function (data) {
        addRumAction('ai_fill_form_start', __assign({ title: 'AI填单开始', hash_path: location.hash, timestamp: Date.now(), device_type: DeviceType.PC, event_start_time: Date.now() }, data));
    };
    AIFillFormTracker.trackAIFillFormSubmit = function (data) {
        addRumAction('ai_fill_form_submit', __assign({ title: 'AI填单提交', hash_path: location.hash, timestamp: Date.now(), device_type: DeviceType.PC, event_end_time: Date.now() }, data));
    };
    AIFillFormTracker.trackAIFillFormSummary = function (data) {
        addRumAction('ai_fill_form_summary', __assign({ title: 'AI填单摘要', hash_path: location.hash, timestamp: Date.now() }, data));
    };
    AIFillFormTracker.trackAIFillFormSummaryResult = function (data) {
        addRumAction('ai_fill_form_summary_result', __assign({ title: 'AI填单摘要结果', hash_path: location.hash, timestamp: Date.now(), event_display_time: Date.now() }, data));
    };
    AIFillFormTracker.trackAIFillFormModify = function (data) {
        addRumAction('ai_fill_form_modify', __assign({ title: 'AI填单字段人工修改', hash_path: location.hash, timestamp: Date.now(), event_modified_time: Date.now() }, data));
    };
    AIFillFormTracker.generateAiId = function (content) {
        var hash = 0;
        if (content.length === 0)
            return hash.toString();
        for (var i = 0; i < content.length; i++) {
            var char = content.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash;
        }
        return "ai_" + Math.abs(hash).toString(36);
    };
    AIFillFormTracker.trackAIFeedback = function (data) {
        var _a, _b, _c, _d;
        var trackingData = __assign(__assign({}, data), { ai_id: data.content ? this.generateAiId(data.content) : '' });
        var userInfo = (_a = app.getState()['@common']) === null || _a === void 0 ? void 0 : _a.userinfo;
        addRumAction('ai_feedback', __assign({ title: data.action === 'like' ? 'AI摘要反馈点赞' : 'AI摘要反馈点踩', corpName: (_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.corporation) === null || _b === void 0 ? void 0 : _b.name, staff_id: (_c = userInfo === null || userInfo === void 0 ? void 0 : userInfo.staff) === null || _c === void 0 ? void 0 : _c.id, staff_name: (_d = userInfo === null || userInfo === void 0 ? void 0 : userInfo.staff) === null || _d === void 0 ? void 0 : _d.name, hash_path: location.hash, timestamp: Date.now() }, trackingData));
    };
    return AIFillFormTracker;
}());
export { AIFillFormTracker };
